export default __webpack_public_path__ + "static/media/lexington-logo.bd181ad8.png";